/**
 * CLARTEXT · A1 (Feb 2026) — Aushangpflicht-Anzeige · Mitarbeiterseite.
 *
 * Rein listend, keine Auth-Logik (Route ist über ProtectedMonteurRoute
 * gehüllt). Lädt `/api/me/aushang`; 403 → freundlicher Hinweis, kein Redirect.
 */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import AushangList from "@/components/AushangList";
import { useMonteurT } from "@/i18n/monteur";

export default function MonteurAushang() {
  const navigate = useNavigate();
  const t = useMonteurT();
  const [data, setData] = useState(null);
  const [forbidden, setForbidden] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    let cancelled = false;
    api
      .getMyAushang()
      .then((res) => {
        if (!cancelled) setData(res);
      })
      .catch((err) => {
        if (cancelled) return;
        const status = err?.response?.status;
        if (status === 403) setForbidden(true);
        else setErrorMsg(t("aushang.loadError"));
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="min-h-screen bg-slate-50" data-testid="monteur-aushang-page">
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-2xl mx-auto px-5 py-4 flex items-center gap-3">
          <button
            type="button"
            onClick={() => navigate("/monteur")}
            className="inline-flex items-center gap-1 text-sm text-slate-600 hover:text-slate-900"
            data-testid="monteur-aushang-back"
            aria-label={t("common.back")}
          >
            <ArrowLeft className="w-4 h-4" />
            {t("common.back")}
          </button>
          <div className="flex-1" />
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-5 py-6 space-y-6">
        <div>
          <p className="text-xs uppercase tracking-widest text-slate-500 font-medium">
            {t("aushang.kicker")}
          </p>
          <h1 className="font-heading text-2xl sm:text-3xl font-bold text-slate-900 mt-1">
            {t("aushang.pageTitle")}
          </h1>
          <p className="text-sm text-slate-600 mt-2">
            {t("aushang.intro")}
          </p>
        </div>

        {forbidden ? (
          <div
            className="border border-amber-200 bg-amber-50 text-amber-900 rounded-md p-4 text-sm"
            data-testid="monteur-aushang-forbidden"
          >
            {t("common.notEnabled")}
          </div>
        ) : errorMsg ? (
          <div
            className="border border-red-200 bg-red-50 text-red-900 rounded-md p-4 text-sm"
            data-testid="monteur-aushang-error"
          >
            {errorMsg}
          </div>
        ) : (
          <AushangList data={data} />
        )}
      </main>
    </div>
  );
}
